"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Info = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var InfoOutlined_1 = __importDefault(require("@material-ui/icons/InfoOutlined"));
exports.Info = function (_a) {
    var text = _a.text;
    return (react_1["default"].createElement(core_1.Tooltip, { title: text },
        react_1["default"].createElement(InfoOutlined_1["default"], null)));
};
